import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getHardwareById } from "../../actions/doctorActions";
import Loader from "../loader/Loader";
import { formatDateTime } from "../../helper";

export default function DeviceDetail() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginData.token);
  const { loading, device } = useSelector((state) => state.hardwareDevice);

  useEffect(() => {
    dispatch(getHardwareById(token, params.id)).catch((error) => {
      toast.error("Error fetching device");
      history.push("/hardware");
    });
  }, [dispatch, token, params.id]);

  const handleBack = () => {
    window.history.back();
  };

  const renderInfoRow = (label, value, formatter = (val) => val) => (
    <div className="form-detail-row">
      <span className="form-detail-label">{label}</span>
      <span className="form-detail-value">
        {value ? formatter(value) : "N/A"}
      </span>
    </div>
  );

  const mapYesNo = (value) => (value ? "Yes" : "No");

  if (loading) return <Loader />;
  if (!device) return <div>No device data available</div>;

  return (
    <div className="concussion-form-detail">
      <div className="d-header">
        <ArrowBackIcon
          fontSize="large"
          onClick={handleBack}
          className="back-detail"
        />
        <div>
          <h3>Hardware Device Details</h3>
          <p className="text-center mb-5">
            {formatDateTime(device.created_at)}
          </p>
        </div>
      </div>

      <div className="form-details-container">
        <div className="details-section">
          <h4>Basic Information</h4>
          {renderInfoRow("Serial Number", device.serial_number)}
          {renderInfoRow("Batch Number", device.batch_number)}
          {renderInfoRow("BLE Address", device.ble_address)}
          {renderInfoRow("Manufacture Date", device.manufacture_date)}
          {renderInfoRow("Manufacture Location", device.manufacture_location)}
          {renderInfoRow("Hardware Revision", device.hardware_revision)}
        </div>

        <div className="details-section">
          <h4>Testing Information</h4>
          {renderInfoRow("Tested Date", device.tested_date)}
          {renderInfoRow("Tested By", device.tested_by)}
          {renderInfoRow("Passed Testing", device.passed_testing, mapYesNo)}
          {renderInfoRow("Test Notes", device.test_notes)}
        </div>

        <div className="details-section">
          <h4>Deployment</h4>
          {renderInfoRow("Status", device.status)}
          {renderInfoRow("Deployed Date", device.deployed_date)}
          {renderInfoRow("Assigned User ID", device.user)}
        </div>

        <div className="details-section">
          <h4>Damage Report</h4>
          {renderInfoRow("Is Damaged", device.is_damaged, mapYesNo)}
          {renderInfoRow("Damage Description", device.damage_description)}
          {renderInfoRow("Damage Reported Date", device.damage_reported_date)}
        </div>

        <div className="details-section">
          <h4>Additional Notes</h4>
          {renderInfoRow("Notes", device.notes)}
          {renderInfoRow("Last Updated", device.updated_at, formatDateTime)}
        </div>
      </div>
    </div>
  );
}
